import { FC, useCallback } from "react";
import { EnterpriseAuthImagePanel } from "./component/ImagePanel";
import { EnterpriseAuthContainer } from "./component/EnterpriseAuthContainer";
import { Link, useLocation } from "react-router-dom";
import { TbChevronLeft } from "react-icons/tb";
import useFetch from "../../hooks/useFetch";
import { toast } from "react-toastify";
import { ResendVerificationApi } from "../../API/auth";

export const VerifyEmailPage: FC = () => {
  const { state } = useLocation();
  const { load } = useFetch();
  const email = state?.email;
  const isForgetPassword = state?.isForgetPassword;

  const title = isForgetPassword ? "Forget Password" : "Verify Email";

  const message = isForgetPassword
    ? "A recovery link was sent to your email"
    : "A verification mail was sent to your email";

  const handleResendEmailButton = useCallback(async () => {
    const payload = {
      email,
    };
    load(ResendVerificationApi(payload)).then(() => {
      toast.success("Email sent successfully");
    });
  }, [email, load]);

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <EnterpriseAuthContainer>
        <>
          <div className="flex flex-col gap-2">
            <p className="text-3xl font-semibold text-black font-satoshi">
              {title}
            </p>
            <p className="text-bash font-medium text-sm font-satoshi">
              {message},{" "}
              <span className="text-black font-medium text-sm font-satoshi">
                {email}
              </span>
            </p>
          </div>
          <div className="">
            <p className="text-bash font-medium text-base font-satoshi">
              Didn’t get link in your inbox?
            </p>
            <p className="text-bash font-medium text-base font-satoshi">
              Check your spam folder or{" "}
              <span
                onClick={handleResendEmailButton}
                className="text-bblue hover:underline"
              >
                Resend Email
              </span>
            </p>
          </div>
          <Link
            to="/enterprise/signin"
            className="flex items-center self-center gap-1 text-center text-sm font-medium font-satoshi text-bblue hover:underline"
          >
            <TbChevronLeft size={16} />
            <p>Back to sign in</p>
          </Link>
        </>
      </EnterpriseAuthContainer>

      <EnterpriseAuthImagePanel />
    </div>
  );
};
